// extracted by mini-css-extract-plugin
module.exports = {"background":"background-module--background--2B-Ab","_children":"background-module--_children--2rSaM"};